import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EvaluacionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "EvaluacionPage",
            ss: ss,
            ajax: {
                "url": ss.indexEvaluacion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Evaluacion', name: 'Evaluacion', title: 'Evaluacion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            evaluacions: [],
            evaluacion: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newEvaluacion() {
            this.evaluacion = {};
            this.$refs['frm-evaluacion'].show();
        },
        showEvaluacion(id) {
            this.isLoading=true;
            this.ss.showEvaluacion(id).then(
                (result) => {
                    let response = result.data;
                    this.evaluacion = response.data;
                    this.$refs['view-evaluacion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editEvaluacion() {
            this.$refs['frm-evaluacion'].show();
            this.$refs['view-evaluacion'].hide();
        },
        cancelEvaluacion() {
            if (this.evaluacion.id) {
                this.$refs['view-evaluacion'].show();
            }
            this.$refs['frm-evaluacion'].hide();
        },
        saveEvaluacion() {
            this.ss.storeEvaluacion(this.evaluacion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-evaluacion'].hide();
                    this.$refs['datatable-evaluacion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEvaluacion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyEvaluacion(this.evaluacion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-evaluacion'].hide();
                                this.$refs['datatable-evaluacion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Evaluacion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEvaluacion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario'));
        if (!usuario) {
          this.$router.push('/Login');
        }
    }
};
